import { CatList } from '@blocks-react/components/List';
import { ReactElement } from 'react';

export type EquipmentMoreActionListProps = {
  children?: ReactElement;
};

export type CustomerAccountEquipmentMoreActionsListProps = {
  children?: ReactElement;
  classname?: string;
};

export const EquipmentMoreActionList = ({
  children
}: EquipmentMoreActionListProps) => {
  return <CatList>{children}</CatList>;
};
